<template>

    <span @click="change($event)">{{ $t(t) }}</span>

</template>


<script>
export default {

    props: {
        t: {
            type: String,
            default: '',
            required: true
        }
    },

    data: () => ({

    }),

    created() {

    },

    mounted() {

    },


    methods: {

        change(e) {

            if(!e.altKey) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();

            // set new language string in our store
            this.$store.commit('SET_CURRENT_LANG_STRING', this.t);

            // show modal
            this.$store.commit('SHOW_MODAL_LANGUAGE', true);

        },

    }

}

</script>
